<script> 
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satdosyaihalekomisyonu from "@/models/satdosyaihalekomisyonu";


export default {
  mixins: [apibtoast, apigeneric, satdosyaihalekomisyonu],
  props: [ "satdosyaId","TableUpdate"],
  data() {
    return {
      FormData: {},
      KurumBilgisi :[],
      ihaleilani:[],
      Dosya:{},
      Alimturu:"",
          Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
    };
  },
  components: {
    Loader

 
  },
  watch: {
    satdosyaId() {

      this.FormData.Dosyaid = this.satdosyaId;
     
    },
    TableUpdate(){
      this.Get();
    }
  },
    created(){
    this.Get();
  },
  methods: {  

    Get() {


       this.ActionsGet({"Service":"OKurumSabit", "Page":this.Page}).then((res) => {

        this.KurumBilgisi = res.Data[0];

      });

         this.ActionsSingleGet({
        Service: "satdosya",
        Id: this.satdosyaId,
      }).then((res) => {
    
        this.FormData = res.Data;
        this.$emit("TableUpdate",false);

             this.ActionsGet({"Service":"OkeyValues/"+this.Dosya.Alimturu, "Page":this.Page}).then((res) => {
                  if(res){
                    if (res.Data.Value=="Mal")
                    {this.Alimturu="M";} 
                    else if (res.Data.Value=="Hizmet"){
                        this.Alimturu="H";
                    }
                     

                  }
             });


      });


      

    }, 

    Export2Word(element, filename = 'Görevlendirme Yazısı'){
    var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
    var postHtml = "</body></html>";
    var html = preHtml+document.getElementById(element).innerHTML+postHtml;

    var blob = new Blob(['\ufeff', html], {
        type: 'application/msword'
    });
    
    // Specify link url
    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    
    // Specify file name
    filename = filename?filename+'.doc':'document.doc';
    
    // Create download link element
    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);
    
    if(navigator.msSaveOrOpenBlob ){
        navigator.msSaveOrOpenBlob(blob, filename);
    }else{
        // Create a link to the file
        downloadLink.href = url;
        
        // Setting the file name
        downloadLink.download = filename;
        
        //triggering the function
        downloadLink.click();
    }
    
    document.body.removeChild(downloadLink);
   },
            
     
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="gorevlendirmeyazisi"
      size="xl"
      class="a4"
      title="Teknik Şartname Komisyonu Görevlendirme Yazısı"
      title-class="font-18"
      hide-footer
    >  

              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
     
                    <button
                      type="button"
                      class="btn btn-warning btn-rounded mb-2 me-2"
                      @click="Export2Word('exportContent')" 
                    >
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      Word'e Aktar
                    </button>
                  </div>
                </div>
              </div>

    

<div id="exportContent">     

  <div class="a4" style="margin-left:20px; " >
    <p style="text-align: center;"><strong>TEKNİK ŞARTNAME KOMİSYONU</strong></p>
  <div style=" margin: 10px" class="table-responsive">

      <table >
          <tbody>
            
              <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">İdarenin adı</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;">{{KurumBilgisi.Kurumadi}}</td>
              </tr>
              <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">İşin adı</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;">{{FormData.Dosyaadi}}</td>
              </tr>

          </tbody>
      </table>
  </div>



  <p>&nbsp;</p>


    <div  class="table-responsive">
        <table style="border: 1px solid; border-collapse: collapse; width: 97%" class="table  table-sm table-bordered border-success mb-0">
          <tbody>
            <tr>
             
              <th style="border: 1px solid;">Adı Soyadı</th>
              <th style="border: 1px solid;">Ünvanı</th>
            </tr>

          <tr v-for="Data in FormData.Tekniksartnamekomisyonu" :key="Data.Id">
            <td style="border: 1px solid;">{{Data.AdSoyad}}</td>
            <td style="border: 1px solid;">{{Data.Unvan}}</td>        
          </tr>
          </tbody>
        </table>

    </div>









              <footer> 
       <p style="text-align: right;">Standart Form ― KİK005.0/{{Alimturu}} <br>
        Teknik Şartname Komisyonu Görevlendirme Yazısı</p>

            </footer>

            </div>
          </div>



    </b-modal>
  </Loader>
</template>

<style>

 .a4 {

	width: 29cm;
	height: 20.5cm;
	position: relative;
}
.a4 footer {
	position: absolute;
	bottom: 5px;
	right: 10px;
}

.yazi{

   font-family: Arial, Helvetica, sans-serif;
   font-size: 12px; 
   line-height: 15px;
   
}
    
</style>